<template>
    <section>
        <!-- <iframe src="http://223.99.217.146:10032/disp/" scrolling="no" style="width: 1100px;height: 520px;" frameborder="0"></iframe> -->

        	<!--列表-->
		<el-table :data="projects" highlight-current-row v-loading="listLoading"  style="width: 100%;margin-top:20px" border :height="formHeight" >
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
            <el-table-column prop="name" label="名称"  min-width="200" sortable>
			</el-table-column>
			<el-table-column prop="city" label="城市" sortable>
			</el-table-column>
            <el-table-column prop="person" label="联系人" sortable>
			</el-table-column>
			<el-table-column prop="buildTime" label="开始时间" min-width="120" >
			</el-table-column>
			<!-- <el-table-column prop="BiName" label="BI名称">
			</el-table-column> -->
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<table-query-button   @select-type="handleEdit(scope.$index, scope.row)" btnCon="查看">  </table-query-button>
					<!-- <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total"
			 style="float:right;" :page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>
    </section>
</template>
<script>
	import util from '../../common/js/util'
	import {getProjectList} from '../../api/api';
    
	import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

	export default {
	components: { TableQueryButton},
        data() {
			return {
				projects: [],
				total: 0,
                page:1,
				pageSize:50,
				listLoading: false,
				formHeight:0,
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page=val;
				this.getProjects();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getProjects();
			},
			//获取设备类型列表
			getProjects() {
				let para = {
                    page: this.page,
                    limit:this.pageSize,
                    Name: "",
					City:""
                };
				this.listLoading = true;
				getProjectList(para).then((res) => {  
					this.listLoading = false;                  
					this.total = res.data.data.total;
					this.projects = res.data.data.records;

					var countFather=0;
					var countChild=0;
					var rowChild;
					var rowFather;
					for (let index = 0; index < this.projects.length; index++) {
						const element = this.projects[index];
						if(element.fatherProId!=0){
							countFather++;
							rowFather=element;
						}else{
							countChild++;
							rowChild=element;
						}
					}

					if(countFather==1){//只有一个父亲，直接跳转到父亲
						this.handleEdit(1,rowFather);
					}else if(countChild==1){//只有一个儿子
						this.handleEdit(1,rowChild);
					}
				});
            },
            //显示修改界面
			handleEdit: function (index, row) {
				// window.open("http://223.99.217.146:10029/dataVis/BI/#/?id="+row.ProjectId);
				window.open(window.configuration.resourceUrlWeb+"dataVis/BI/#/?id="+row.projectId);
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-80-20;
			}
		},
        mounted() {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getProjects();
        }
    }
</script>


// WEBPACK FOOTER //
// BIWeb.vue?1886c75d